import { PathCardProps } from "../../../pages/cpas-platform/types";

export const PathCard: React.FC<PathCardProps> = ({
  activeIcon,
  inactiveIcon,
  activeCheckIcon,
  inactiveCheckIcon,
  title,
  description,
  features,
}) => {


  return (
    <div className="md:h-[450px] p-6 transition-all cursor-pointer group">
      
      {/* Icons */}
      <div className="mb-4">
        <span className="group-hover:hidden">{inactiveIcon}</span>
        <span className="hidden group-hover:inline">{activeIcon}</span>
      </div>

      <h3 className="text-2xl text-[#3A3428] font-medium mb-2">
        {title}
      </h3>

      <p className="text-gray-600 mb-6">
        {description}
      </p>

      {features && (
        <ul className="space-y-2">
          {features.map((feature, idx) => (
            <li
              key={idx}
              className="flex items-center gap-2 text-sm text-gray-700"
            >
              <span className="group-hover:hidden">
                {inactiveCheckIcon}
              </span>
              <span className="hidden group-hover:inline">
                {activeCheckIcon}
              </span>
              {feature}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
